
import { CompanyService } from "@/services/company-service";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { setTitle, resetTitle } from "@/utils/title";
import AppFetchingSpinnerOverlay from "@/components/FetchingSpinnerOverlay.vue";
import { Dossier } from "@/models/dossier";

interface IDataTableColumnExtended extends IDataTableColumn {
	dbName?:string;
}

export default Vue.extend({
	data() {
		return {
			dossiers: [] as Dossier[],
			selectedItems: [] as Dossier[],
			ready: false,
			isFetching: false
		};
	},
	computed: {
		title():string{
			return "Verplaatst naar db2 maar niet verwijderd";
		},
		// eslint-disable-next-line max-lines-per-function
		columns():IDataTableColumnExtended[] {
			let _t = this;
			return [
				{
					name: "ID",
					property: "id",
					width: "50px",
				},
				{
					name: "Dossier naam",
					property: "name",
					width: "200px",
				},
				{
					name: "Klant naam",
					property: "company.name",
					click: (item:Dossier)=>{
						if (!item.company) return;
						_t.$router.push(`/companies/${item.company.id}/edit`);
					}
				},
			] as IDataTableColumnExtended[];
		},
		deleteDisabled():boolean{
			return this.selectedItems.length != 1;
		}
	},
	methods: {
		async getDossiers() {
			if (!this.ready) return;
			this.isFetching = true;
			let response = await CompanyService.getMovedToButNotDeletedDossiers();
			this.isFetching = false;
			this.dossiers = response;
		},
		async deleteDossier(){
			if (this.selectedItems.length != 1) return;
			await CompanyService.deleteDossier(this.selectedItems[0].id);
			this.getDossiers();
		}
	},
	async created(){
		setTitle(this.title);
		requestAnimationFrame(()=>{
			this.ready = true;
			this.getDossiers();
		});
	},
	destroyed(){
		resetTitle();
	},
	components: {
		AppFetchingSpinnerOverlay
	}
});
